import Marker from "./Marker";
import Resource from "./resource";
import Viewer from "./viewer";

export default {
  Marker,
  Resource,
  Viewer
};
